import { render, staticRenderFns } from "./PensionSolution.vue?vue&type=template&id=29c3b24c&scoped=true&"
import script from "./PensionSolution.vue?vue&type=script&lang=js&"
export * from "./PensionSolution.vue?vue&type=script&lang=js&"
import style0 from "./PensionSolution.vue?vue&type=style&index=0&id=29c3b24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c3b24c",
  null
  
)

export default component.exports